import _asyncToGenerator from "F:/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "message-input-wrapper"
};
import { TUIStore, StoreName } from '@tencentcloud/chat-uikit-engine';
import { ref } from '../../../adapter-vue';
import MessageInputEditor from './message-input-editor.vue';
import MessageInputAt from './message-input-at/index.vue';
import MessageInputButton from './message-input-button.vue';
import MessageInputQuote from './message-input-quote/index.vue';
import { sendMessages, sendTyping } from '../utils/sendMessage';
import { isPC, isH5 } from '../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    placeholder: {
      type: String,
      default: 'this is placeholder'
    },
    isMuted: {
      type: Boolean,
      default: true
    },
    muteText: {
      type: String,
      default: ''
    },
    enableInput: {
      type: Boolean,
      default: true
    },
    enableAt: {
      type: Boolean,
      default: true
    },
    enableDragUpload: {
      type: Boolean,
      default: true
    },
    enableTyping: {
      type: Boolean,
      default: true
    }
  },
  emits: ['sendMessage', 'resetReplyOrReference', 'onTyping'],
  setup(__props, _ref) {
    var {
      expose: __expose,
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var editor = ref();
    var messageInputAtRef = ref();
    var _currentConversation = ref();
    TUIStore.watch(StoreName.CONV, {
      currentConversation: conversation => {
        _currentConversation.value = conversation;
      }
    });
    var onTyping = (inputContentEmpty, inputBlur) => {
      sendTyping(inputContentEmpty, inputBlur);
    };
    var onAt = show => {
      var _messageInputAtRef$va;
      (_messageInputAtRef$va = messageInputAtRef.value) === null || _messageInputAtRef$va === void 0 || _messageInputAtRef$va.toggleAtList(show);
    };
    var sendMessage = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* () {
        var _editor$value, _editor$value2;
        var _editorContentList = (_editor$value = editor.value) === null || _editor$value === void 0 ? void 0 : _editor$value.getEditorContent();
        if (!_editorContentList || !_currentConversation.value) return;
        var editorContentList = _editorContentList.map(editor => {
          if (editor.type === 'text') {
            // editor.payload.text = transformEmojiValueToKey(editor.payload.text)
          }
          return editor;
        });
        yield sendMessages(editorContentList, _currentConversation.value);
        emit('sendMessage');
        (_editor$value2 = editor.value) === null || _editor$value2 === void 0 || _editor$value2.resetEditor();
      });
      return function sendMessage() {
        return _ref2.apply(this, arguments);
      };
    }();
    var insertEmoji = emoji => {
      var _editor$value3;
      (_editor$value3 = editor.value) === null || _editor$value3 === void 0 || _editor$value3.addEmoji(emoji);
    };
    var onAtListOpen = () => {
      if (isH5) {
        var _editor$value4;
        (_editor$value4 = editor.value) === null || _editor$value4 === void 0 || _editor$value4.blur();
      }
    };
    var insertAt = atInfo => {
      var _editor$value5, _editor$value6;
      (editor === null || editor === void 0 || (_editor$value5 = editor.value) === null || _editor$value5 === void 0 ? void 0 : _editor$value5.insertAt) && (editor === null || editor === void 0 || (_editor$value6 = editor.value) === null || _editor$value6 === void 0 ? void 0 : _editor$value6.insertAt(atInfo));
    };
    var reEdit = content => {
      var _editor$value7, _editor$value8;
      (_editor$value7 = editor.value) === null || _editor$value7 === void 0 || _editor$value7.resetEditor();
      // resetReplyOrReference();
      (_editor$value8 = editor.value) === null || _editor$value8 === void 0 || _editor$value8.setEditorContent(content);
    };
    __expose({
      insertEmoji,
      reEdit
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(['message-input-container', !_unref(isPC) && 'message-input-container-h5'])
      }, [_createVNode(MessageInputEditor, {
        ref_key: "editor",
        ref: editor,
        placeholder: props.placeholder,
        isMuted: props.isMuted,
        muteText: props.muteText,
        enableInput: props.enableInput,
        enableAt: props.enableAt,
        enableTyping: props.enableTyping,
        enableDragUpload: props.enableDragUpload,
        onSendMessage: sendMessage,
        onOnTyping: onTyping,
        onOnAt: onAt
      }, null, 8, ["placeholder", "isMuted", "muteText", "enableInput", "enableAt", "enableTyping", "enableDragUpload"]), !props.isMuted ? (_openBlock(), _createBlock(MessageInputButton, {
        key: 0,
        onSendMessage: sendMessage
      })) : _createCommentVNode("", true), props.enableAt ? (_openBlock(), _createBlock(MessageInputAt, {
        key: 1,
        ref_key: "messageInputAtRef",
        ref: messageInputAtRef,
        onInsertAt: insertAt,
        onOnAtListOpen: onAtListOpen
      }, null, 512)) : _createCommentVNode("", true)], 2), _createVNode(MessageInputQuote)]);
    };
  }
});